<template>
  <span>
    <router-link :to="{name: 'sales.view', params: {id: auctionUuid}}"
                 v-if="$hasPermission('view_auction') && !enableContinuousAuction">
              {{ saleNo }}
    </router-link>
    <span v-else>
      {{ saleNo }}
    </span>
  </span>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "LinkedSaleNo",
    props: ['saleNo', 'auctionUuid'],
    computed: {
      ...mapStateGlobal([
        'enableContinuousAuction'
      ]),
    },
  }
</script>

<style scoped>

</style>
